import { ButtonHTMLAttributes } from 'react';
import {
	STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME,
	STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME,
	STANDARD_BUTTON_TEXT_SIZE_CLASSNAME,
	STANDARD_BUTTON_DISABLED_CLASSNAME,
} from 'src/components/primitives/Button/consts';
import { cm } from 'src/utils/classNames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	label: string;
	isActive: boolean;
	activeClassName?: string;
	inactiveClassName?: string;
}

export default function ToggleTabButton({
	className,
	label,
	isActive,
	activeClassName,
	inactiveClassName,
	...rest
}: Props) {
	return (
		// rounded-2xl intentionally one step smaller than ToggleTabs container — optical-illusion convention.
		<button
			className={cm(
				'z-10 flex-1 rounded-2xl transition-colors',
				isActive
					? (activeClassName ?? 'text-text-default')
					: (inactiveClassName ?? 'text-text-default'),
				STANDARD_BUTTON_HORIZONTAL_PADDING_CLASSNAME.md,
				STANDARD_BUTTON_VERTICAL_PADDING_CLASSNAME.md,
				STANDARD_BUTTON_TEXT_SIZE_CLASSNAME.md,
				STANDARD_BUTTON_DISABLED_CLASSNAME,
				className
			)}
			{...rest}
		>
			{label}
		</button>
	);
}
